// src/store/selectors.js
export const selectForm = (state) => state.form;
export const selectInfo = (state) => state.form.info;
export const selectCriteria = (state) => state.form.criteria;
export const selectEvaluations = (state) => state.form.evaluations;

export const selectLessons = (state) => state.form.lessons;
export const selectCurrentLessonNo = (state) => state.form.currentLessonNo;
